/**
 * Indicates how the time log entry was created or modified
 */
export enum LogMode {
  /** log created automatically (e.g. via a timer) */
  Auto = 0,
  /** log  created manually by a user */
  ManuallyCreated = 1,
  /** an existing log was edited manually */
  Edited = 2,
}
